export default "__VITE_ASSET__545953d0__"